import {GET_WALLET, REQUEST_WALLET, CLEAR_WALLET} from "../actions/Wallet"

const defaultState = {
  availableBalance: 0,
  availableBalanceInCents: 0,
  scheduledInBalance: 0,
  currency: "",
  uuid: null,
  requested: false,
  ownerUuid: null
}

const WalletReducer = (state = defaultState, action) => {
  const {wallet} = action

  switch (action.type) {
    case GET_WALLET:
      return get(state, Object.assign({}, wallet, {requested: true}))
    case REQUEST_WALLET:
      return {...state, requested: true}
    case CLEAR_WALLET:
      return {...defaultState, requested: false}
    default:
      return state
  }
}

export default WalletReducer

const get = (state, wallet) => wallet || state.wallet
